import { Fragment } from 'react';
import type { ControllerRenderProps } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';
import type { SwitchProps } from '@mui/material';
import { FormHelperText, Switch } from '@mui/material';

// ----------------------------------------------------------------------

export type RHFSwitchProps = Omit<SwitchProps, keyof ControllerRenderProps> & {
  name: string;
  helperText?: React.ReactNode;
};

export const RHFSwitch = (props: RHFSwitchProps) => {
  const { name, helperText, ...restOfProps } = props;

  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const hasError = !!error;

        return (
          <Fragment>
            <Switch {...restOfProps} {...field} checked={field.value} />

            {(hasError || helperText) && (
              <FormHelperText error={hasError}>{hasError ? error?.message : helperText}</FormHelperText>
            )}
          </Fragment>
        );
      }}
    />
  );
};
